import { GraphQLQuery } from '@aws-amplify/api';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetUserQuery, User } from 'src/API';
import { crudReducer, crudSlice, CrudStatus } from './crud-state-slice';

type UserBaseState = {
  // organizations: OrganizationObject[]
  account?: User | null;
};

type UserState = UserBaseState & CrudStatus<UserBaseState>;

const initialState: UserState = {
  ...crudSlice,
  account: undefined,
  // organizations: []
};

type SetListAction = PayloadAction<string[]>;
// type SetListOrganizationAction = PayloadAction<OrganizationObject[]>
type UpdateUserAction = PayloadAction<User>;

const reducers = {
  ...crudReducer<UserState>(),
  setGroups(state: UserState, action: SetListAction) {
    // state.groups = action.payload;
  },
  updateAccount(state: UserState, action: UpdateUserAction) {
    state.account = action.payload;
  },
  getAccount(state: UserState, action: PayloadAction<GraphQLQuery<GetUserQuery> | undefined>) {
    if (!action.payload) return;
    state.account = action.payload.getUser;
  },
};

export const slice = createSlice({
  name: 'user',
  initialState,
  reducers,
});

export const { reducer } = slice;
